import { render, staticRenderFns } from "./login-confirm.vue?vue&type=template&id=560cdf8b&scoped=true"
import script from "./login-confirm.vue?vue&type=script&lang=js"
export * from "./login-confirm.vue?vue&type=script&lang=js"
import style0 from "./login-confirm.styl?vue&type=style&index=0&id=560cdf8b&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560cdf8b",
  null
  
)

export default component.exports